import { useTranslation } from "react-i18next";
import type { DocumentVersionRef } from "../../../shared/references/contentReferences";
import { useDocumentName } from "./useSourceDocument";

/**
 * A document version as people read it: its name, or "Document" until the name is read, if it can't be, or without a
 * reference. Never its ID (F77, F78, F94, F163): the one rule every place that names a document follows.
 */
export function useDocumentLabel(reference: DocumentVersionRef | null): string {
  const { t } = useTranslation();
  return useDocumentName(reference) ?? t("sources.document.unnamed");
}
